document.addEventListener('DOMContentLoaded', function () {

  // *.*.*.*.*.*.*.*.*.*.* theme color *.*.*.*.*.*.*.*.*.*.*
  const darkBtn = document.querySelector('.theme-switcher-dark');
  const lightBtn = document.querySelector('.theme-switcher-light');

  function applyTheme(theme) {
    const root = document.documentElement;
    
    if (theme === 'dark') {
      root.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      root.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }

  function loadTheme() {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      applyTheme(savedTheme);
    } else {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      applyTheme(prefersDark ? 'dark' : 'light');
    }
  }

  darkBtn.addEventListener('click', () => applyTheme('dark'));
  lightBtn.addEventListener('click', () => applyTheme('light'));

  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', e => {
    if (!localStorage.getItem('theme')) {
      applyTheme(e.matches ? 'dark' : 'light');
    }
  });

  window.addEventListener('DOMContentLoaded', loadTheme);

  // *.*.*.*.*.*.*.*.*.*.* theme color *.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* OPEN SEARCH *.*.*.*.*.*.*.*.*.*.*
  const open = document.querySelector('.search_open');
  const box = document.querySelector('#search_box');
  const close = document.querySelector('.search_close');
  open.addEventListener('click', () => {
    setTimeout(() => {
      box.classList.toggle('hidden');
      box.classList.toggle('block');
    }, 10);
  });  
  close.addEventListener('click', () => {
    setTimeout(() => {
      box.classList.toggle('hidden');
    }, 10);
  });
  // *.*.*.*.*.*.*.*.*.*.* OPEN SEARCH *.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* START OF show hide author content *.*.*.*.*.*.*.*.*.*.*
  if (document.querySelector('.profile_content_display')) {
    if (document.querySelector(".profile_content_display").scrollHeight > 250) {
      document.querySelector(".profile_content_button").addEventListener('click', function () {
        document.querySelector(".profile_content_display").classList.toggle('profile_content_display_show');
        document.querySelector(".profile_content_display").style.maxHeight = document.querySelector(".profile_content_display").scrollHeight + "px";
        document.querySelector(".profile_content_button").style.display = "none";
      })
    } else {
      if (document.querySelector('.profile_content_display')) {
        document.querySelector(".profile_content_button").style.display = "none";
      }
    }
  }
  // *.*.*.*.*.*.*.*.*.*.* END OF show hide author content *.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* START OF TABS *.*.*.*.*.*.*.*.*.*.*
  function setupTabs(tabButtons, contentBoxes, container) {
    const tabs = Array.from(container.querySelectorAll(tabButtons));
    const contents = Array.from(container.querySelectorAll(contentBoxes));

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        tabs.forEach((tab, i) => {
          if (i === index) {
            tab.classList.add("active");
            contents[i].classList.add("visible");
          } else {
            tab.classList.remove("active");
            contents[i].classList.remove("visible");
          }
        });
      });
    });
  }

  // Setting up all the main tab containers
  document.querySelectorAll(".primary_multi_tab").forEach((container) => {
    setupTabs(".tabs_title li", ".tab_content", container);
  });
  // *.*.*.*.*.*.*.*.*.*.* END OF TABS *.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* START OF MAIN MENU *.*.*.*.*.*.*.*.*.*.*
  const mainMenu = document.querySelector("#top_nav");
  const openButton = document.querySelector("#mobile_menu");
  const closeButton = document.querySelector("#close_menu");
  if (mainMenu && openButton && closeButton) {
    if (window.innerWidth < 1024) {
      function openMenu() {
        mainMenu.classList.remove("hidden");
        requestAnimationFrame(() => {
          mainMenu.classList.remove("translate-x-full");
          mainMenu.classList.add("translate-x-0");
        });
      }

      function closeMenu() {
        mainMenu.classList.add("translate-x-full");
        mainMenu.addEventListener(
          "transitionend",
          () => {
            if (mainMenu.classList.contains("translate-x-full")) {
              mainMenu.classList.add("hidden");
            }
          },
          { once: true }
        );
      }

      if (openButton && mainMenu) {
        openButton.addEventListener("click", openMenu);
      }
      if (closeButton && mainMenu) {
        closeButton.addEventListener("click", closeMenu);
      }

      // ----- SUB_MENU -----
      document.querySelectorAll('.submenu_icon').forEach(subMenuButton => {
        subMenuButton.addEventListener('click', () => {
          const subMenu = subMenuButton.parentNode.nextElementSibling;
          if (subMenu) {
            if (subMenu.classList.contains('hidden')) {
              subMenu.classList.remove('hidden');
              setTimeout(() => {
                subMenu.classList.add('transition-all', 'duration-300');
                subMenu.classList.remove('opacity-0');
                subMenu.classList.add('opacity-100');
                subMenuButton.classList.add('rotate-180');
              }, 10);
            } else {
              subMenu.classList.add('opacity-0');
              subMenu.classList.remove('opacity-100');
              subMenu.classList.add('transition-all', 'duration-300');
              subMenuButton.classList.remove('rotate-180');
              setTimeout(() => {
                subMenu.classList.add('hidden');
              }, 300);
            }
          }
        });
      });
      // ----- END OF SUB_MENU -----
    }
  }
  // *.*.*.*.*.*.*.*.*.*.* END OF MAIN MENU *.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* ARCHIVE TOGGLE *.*.*.*.*.*.*.*.*.*.*
  const flip = document.querySelector(".flip");
  const flip2 = document.querySelector(".flip2");
  const content = document.querySelector(".content-wrapper");
  const content2 = document.querySelector(".content-wrapper2");

  if (flip) {
    flip.addEventListener("click", () => {
      if (content.style.maxHeight && content.style.maxHeight !== "0px") {
        content.style.maxHeight = "0px";
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  }  
  if (flip2) {
    flip2.addEventListener("click", () => {
      if (content2.style.maxHeight && content2.style.maxHeight !== "0px") {
        content2.style.maxHeight = "0px";
      } else {
        content2.style.maxHeight = content2.scrollHeight + "px";
      }
    });
  }
  // *.*.*.*.*.*.*.*.*.*.* END OF ARCHIVE TOGGLE *.*.*.*.*.*.*.*.*.*.*  

  // *.*.*.*.*.*.*.*.*.*.* HEADER NEWS TICKER (seamless loop) *.*.*.*.*.*.*.*.*.*.*
  // clone the items until the list is one track wider than the originals, then
  // slide exactly one originals-width so the loop restarts without a jump
  const tickerLists = document.querySelectorAll('.news_ticker .ticker-list');
  if (tickerLists.length) {
    // width of the original items only (fractional: a rounded offset makes every loop tick)
    function tickerOriginalsWidth(list) {
      const count = Number(list.dataset.tickerCount) || list.children.length;
      let width = 0;
      for (let i = 0; i < count && i < list.children.length; i++) {
        width += list.children[i].getBoundingClientRect().width;
      }
      return width;
    }

    function setupTickerList(list) {
      const track = list.closest('.ticker-track');

      if (!list.dataset.tickerOriginal) {
        list.dataset.tickerOriginal = list.innerHTML;
      }
      list.classList.remove('is-running');
      list.innerHTML = list.dataset.tickerOriginal;

      const originals = Array.from(list.children);
      list.dataset.tickerCount = originals.length;
      const originalWidth = tickerOriginalsWidth(list);
      const trackWidth = track ? track.getBoundingClientRect().width : 0;
      if (!originalWidth) return;

      while (list.getBoundingClientRect().width < originalWidth + trackWidth) {
        originals.forEach((item) => {
          const clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
          list.appendChild(clone);
        });
      }

      list.dataset.tickerWidth = originalWidth;
      list.style.setProperty('--ticker-offset', '-' + originalWidth.toFixed(3) + 'px');
      // speed: ~70px per second (min 12s for a short list)
      list.style.setProperty('--ticker-duration', Math.max(12, originalWidth / 70).toFixed(3) + 's');

      // start (or restart) the animation from its first frame
      void list.offsetWidth;
      list.classList.add('is-running');
    }

    tickerLists.forEach(setupTickerList);

    // the web font can arrive after the first measurement and widen the titles:
    // re-measure once it is ready, and rebuild only if the width really changed
    if (document.fonts && document.fonts.status !== 'loaded') {
      document.fonts.ready.then(() => {
        tickerLists.forEach((list) => {
          if (Math.abs(tickerOriginalsWidth(list) - Number(list.dataset.tickerWidth || 0)) > 0.5) {
            setupTickerList(list);
          }
        });
      });
    }

    let tickerResizeWidth = window.innerWidth;
    window.addEventListener('resize', () => {
      // mobile browsers fire resize on scroll (toolbar show/hide); only rebuild on width changes
      if (window.innerWidth === tickerResizeWidth) return;
      tickerResizeWidth = window.innerWidth;
      tickerLists.forEach(setupTickerList);
    }, { passive: true });
  }
  // *.*.*.*.*.*.*.*.*.*.* END OF HEADER NEWS TICKER *.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* BREAKING NEWS (FRONT_Q, fixed bottom bar) *.*.*.*.*.*.*.*.*.*.*
  const breakingBar = document.getElementById('breaking_news');
  if (breakingBar && !breakingBar.hidden) {
    const breakingItems = Array.from(breakingBar.querySelectorAll('[data-breaking-item]'));
    const breakingScrollBtn = document.getElementById('scrollTopBtn');

    // keep page content and the scroll-to-top button clear of the bar
    const reserveBreakingSpace = () => {
      const h = breakingBar.hidden ? 0 : breakingBar.offsetHeight;
      document.body.style.paddingBottom = h ? h + 'px' : '';
      if (breakingScrollBtn) {
        breakingScrollBtn.style.bottom = h ? (h + 16) + 'px' : '';
      }
    };
    reserveBreakingSpace();
    window.addEventListener('resize', reserveBreakingSpace, { passive: true });

    // rotate items one at a time (pauses while hovered or focused)
    if (breakingItems.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let breakingIndex = 0;
      let breakingPaused = false;
      breakingBar.addEventListener('mouseenter', () => { breakingPaused = true; });
      breakingBar.addEventListener('mouseleave', () => { breakingPaused = false; });
      breakingBar.addEventListener('focusin', () => { breakingPaused = true; });
      breakingBar.addEventListener('focusout', () => { breakingPaused = false; });
      setInterval(() => {
        if (breakingPaused || breakingBar.hidden) return;
        breakingItems[breakingIndex].classList.replace('opacity-100', 'opacity-0');
        breakingItems[breakingIndex].classList.add('invisible');
        breakingIndex = (breakingIndex + 1) % breakingItems.length;
        breakingItems[breakingIndex].classList.remove('invisible');
        breakingItems[breakingIndex].classList.replace('opacity-0', 'opacity-100');
      }, 5000);
    }

    // close: slide down, then remember this set of items for the rest of the session
    const breakingClose = breakingBar.querySelector('[data-breaking-close]');
    if (breakingClose) {
      breakingClose.addEventListener('click', () => {
        try { sessionStorage.setItem('breakingDismissed', breakingBar.dataset.breakingKey); } catch (e) {}
        breakingBar.dataset.closed = '';
        setTimeout(() => {
          breakingBar.hidden = true;
          reserveBreakingSpace();
        }, 500);
      });
    }
  }
  // *.*.*.*.*.*.*.*.*.*.* END OF BREAKING NEWS *.*.*.*.*.*.*.*.*.*.*

  // --- SPLIDE ELEMENT ---
  document.querySelectorAll('.splide').forEach((splideEl) => {
    new Splide(splideEl, {
      type: 'loop',
      perPage: 1,
      pagination: true,
      gap: '1em',
      focus: 'center',
      autoplay: true,
      interval: 3000,
      whell: true,
      flickMaxPages: 1,
      updateOnMove: true,
      direction: document.documentElement.dir === 'rtl' ? 'rtl' : 'ltr',
      arrows: true,
    }).mount();
  });
  // --- SPLIDE ELEMENT ---

  // --- TABS ([data-tabs] > [role=tab] + [role=tabpanel]) ---
  document.querySelectorAll('[data-tabs]').forEach((tabsEl) => {
    const tabs = [...tabsEl.querySelectorAll('[role="tab"]')];
    const select = (tab) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
    };
    tabs.forEach((tab, i) => {
      tab.tabIndex = i === 0 ? 0 : -1;
      tab.addEventListener('click', () => select(tab));
      tab.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        const step = (e.key === 'ArrowRight') === (document.documentElement.dir === 'rtl') ? -1 : 1;
        const next = tabs[(i + step + tabs.length) % tabs.length];
        select(next);
        next.focus();
      });
    });
  });
  // --- TABS ---

  // --- LATEST NEWS "+ MORE" (FRONT_J.ctp: next page of FRONT_O, appended into the box) ---
  // Each click fetches one more page (same size as the box) from newsstudios/ajaxList.
  // From the first load on, the list keeps its original height and scrolls inside the box (lg up;
  // below lg it just grows, so the page scroll is never trapped).
  // Once there is nothing more to load, the button goes back to being a link to search.
  document.querySelectorAll('[data-more-news]').forEach((panel) => {
    const list = panel.querySelector('[data-more-list]');
    const btn = panel.querySelector('[data-more-btn]');
    const tpl = panel.querySelector('[data-more-template]');
    if (!list || !btn || !tpl) return;

    const seen = new Set([...list.querySelectorAll('[data-news-id]')].map((li) => li.dataset.newsId));
    const MAX_PAGE = 75; // core caps ajaxList paging at 75
    let page = 1;
    let loading = false;
    let exhausted = false;
    btn.setAttribute('role', 'button');

    const finish = () => {
      exhausted = true;
      btn.removeAttribute('role');
    };

    const addItem = (news) => {
      const id = String(news.id);
      // relative /<lang>/news/... urls only, so a bad value can never become a javascript: link
      if (seen.has(id) || typeof news.url !== 'string' || !news.url.startsWith('/')) return null;
      seen.add(id);
      const li = tpl.content.firstElementChild.cloneNode(true);
      const a = li.querySelector('a');
      li.dataset.newsId = id;
      a.href = news.url;
      a.title = news.title;
      a.textContent = news.title;
      if (/^[0-9a-f]{3,8}$/i.test(news.color || '')) a.style.color = '#' + news.color;
      list.appendChild(li);
      return li;
    };

    btn.addEventListener('click', async (e) => {
      if (exhausted) return; // let the link open the search page
      e.preventDefault();
      if (loading) return;
      loading = true;
      btn.setAttribute('aria-busy', 'true');
      try {
        const params = new URLSearchParams(panel.dataset.moreQuery);
        params.set('page', page + 1);
        const res = await fetch(panel.dataset.moreUrl + '?' + params, { headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const json = await res.json();
        const items = Array.isArray(json.items) ? json.items : [];
        page += 1;

        // only where the list is a scroll box (lg up); on mobile it just grows with the page
        const scrollsInside = getComputedStyle(list).overflowY !== 'visible';
        if (scrollsInside && !list.style.maxHeight) list.style.maxHeight = list.offsetHeight + 'px';
        let firstNew = null;
        items.forEach((news) => {
          const li = addItem(news);
          if (li && !firstNew) firstNew = li;
        });
        if (firstNew && scrollsInside) list.scrollTo({ top: firstNew.offsetTop, behavior: 'smooth' });

        if (!items.length || page >= MAX_PAGE || page >= (json.pagesCount || 0)) finish();
      } catch (err) {
        console.error('latest news: load more failed', err);
      } finally {
        loading = false;
        btn.removeAttribute('aria-busy');
      }
    });
  });
  // --- LATEST NEWS "+ MORE" ---

  // ---- PAGES SCROLL TO TOP ----
  if(document.getElementById('scrollTopBtn')) {
    const progressCircle = document.getElementById('scrollProgress');
    const scrollButton = document.getElementById('scrollTopBtn');
    const progressRadius = 27;
    const progressCircumference = 2 * Math.PI * progressRadius;

    progressCircle.style.strokeDasharray = progressCircumference;
    progressCircle.style.strokeDashoffset = progressCircumference;

    // Update progress circle and toggle visibility on scroll
    const updateScrollProgress = () => {
      const scrollPosition = window.scrollY;
      const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
      // Show button after scrolling 50px
      if (scrollPosition > 50) {
        scrollButton.classList.remove('hidden');
      } else {
        scrollButton.classList.add('hidden');
      }
      // Update circle stroke offset
      const offset = progressCircumference - (scrollPosition / documentHeight) * progressCircumference;
      progressCircle.style.strokeDashoffset = offset;
    }

    window.addEventListener('scroll', updateScrollProgress);
    // Scroll smoothly to top on click
    scrollButton.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
  // ---- END OF PAGES SCROLL TO TOP ----

  // ------- START OF FEEDS/ALL --------
  if (window.location.pathname === '/feeds/all') {
    document.body.classList.add('feeds');
  }
  // ------ END OF FEEDS/SLL --------

})
